import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import { TypographyNormal } from "../customComponent";
import { usePagination } from "../hooks";
import { getOrganizations } from "../../store/actions/organizationAction";
import OrganizationItem from "./OrganizationItem";
import { colorStyling } from "../../helpers/color";
import Role from "../../helpers/roles";
import { useTranslation } from "react-i18next";

const OrganizationList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const { t } = useTranslation("organization");
  const { t: tCommon } = useTranslation();

  useEffect(() => {
    if (!user?.id) {
      return;
    }

    if (user?.type !== Role.Eins) {
      navigate("/");
      return;
    }

    dispatch(getOrganizations());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const { organizations, loadingOrganization } = useSelector(
    (state) => state.organization
  );

  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
    _DATA.jump(1);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizations]);

  const DATA_PER_PAGE = 5;

  const count = Math.ceil(organizations.length / DATA_PER_PAGE);

  const _DATA = usePagination(organizations, DATA_PER_PAGE);

  const handleChangePagination = (event, page) => {
    setPage(page);
    _DATA.jump(page);
  };

  if (loadingOrganization)
    return (
      <Box
        sx={{ height: "20vh" }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <CircularProgress
          size={20}
          thickness={3}
          sx={{ color: colorStyling.primary }}
        />
        <TypographyNormal sx={{ color: colorStyling.primary, mt: "15px" }}>
          {tCommon("loadingDataList")}
        </TypographyNormal>
      </Box>
    );

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ boxShadow: 3, borderRadius: "6px" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t("table.name")}</TableCell>
              <TableCell>{t("table.viewerLimit")}</TableCell>
              <TableCell>{t("table.subscriptionEnd")}</TableCell>
              <TableCell align="right">{t("table.action")}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {organizations &&
              _DATA
                .currentData()
                .map((organization) => (
                  <OrganizationItem
                    key={organization.id}
                    organization={organization}
                  />
                ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          pt: 4,
          pb: 2,
          pr: 2,
        }}
      >
        <Pagination
          count={count}
          page={page}
          shape="rounded"
          color="primary"
          onChange={handleChangePagination}
        />
      </Box>
    </>
  );
};

export default OrganizationList;
